module.exports = __webpack_public_path__ + "static/img/VehicleRegCertOCR1.1745385299907.jpg";